import { Component, OnInit,OnDestroy } from '@angular/core';
import { ContactService } from 'src/app/serv/contact.service';
import { Contact } from 'src/app/Models/contact';
import { Subscription } from 'rxjs';
import { from } from 'rxjs';
import { DataTableResource } from 'angular5-data-table';

@Component({
  selector: 'app-show-contact',
  templateUrl: './show-contact.component.html',
  styleUrls: ['./show-contact.component.scss']
})
export class ShowContactComponent implements OnInit,OnDestroy {

  contacts: Contact[];
  subscription: Subscription;
  tableResource: DataTableResource<Contact>;
  items: Contact[]=[];
  itemCount: number;
  

  constructor(private contactServices: ContactService) {
    this.subscription = this.contactServices.getAllContact().subscribe(contacts => {
      this.contacts = contacts ;
      this.initializeTable(contacts);
    });
  
  }


  private initializeTable(contacts : Contact[]){
    this.tableResource = new DataTableResource(contacts);
    this.tableResource.query({offset: 0}).then(items => this.items= items);
    this.tableResource.count().then(count =>this.itemCount = count );

  } 
  reloadItems(params){
    if (!this.tableResource) return ;
    this.tableResource.query(params).then(items => this.items = items);
    
    }

    showmsg(contact:Contact){
      console.log('its work'+ contact);
      alert('Sir, Madam: '+ contact.name + '\n'+ contact.message );
      
    }
  ngOnInit(): void {
  }
 
  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

}
